export default "__VITE_ASSET__DO70ersl__"